if ($('.tabs')[0]) {
	const tab = '.tabs__menu li span';
	$(tab).on('click', function(e) {
		const anchor = $(this)
			.attr('class')
			.replace(/^#/, '');
		$('.' + anchor)
			.css('display', 'block')
			.siblings()
			.css('display', 'none');
		$(this)
			.addClass('active')
			.parent()
			.siblings()
			.find('span')
			.removeClass('active');
		e.preventDefault();
	});
}
